import Client from '@/api/client'
import { getConfig } from '@/app/config'
import { Salutation } from '@/features/auth'
import { buildUrl } from '@/routes/utils'
import { LanguageCode } from '@/utils/localisation'

const client = new Client(getConfig().API_ENDPOINT ?? '')
const ACCOUNT_SETTINGS_PAGE_URL = new URL(buildUrl('/settings'), window.location.origin).toString()

export type UpdateUserProps = {
  customerId: string
  userId: string
  data: {
    preferredLanguage?: LanguageCode
    salutation?: Salutation
    title?: string
    firstName?: string
    lastName?: string
    phoneLandline?: string
    phoneMobile?: string
  }
}

export const updateUser = async (props: UpdateUserProps): Promise<void> => {
  await client.put(
    `/api/shipping/api/customers/${props.customerId}/users/${props.userId}?redirectTo=${encodeURIComponent(
      ACCOUNT_SETTINGS_PAGE_URL
    )}`,
    props.data
  )
}

export type UpdateEmailProps = {
  customerId: string
  userId: string
  data: {
    email: string
  }
}

export const updateEmail = async (props: UpdateEmailProps): Promise<void> => {
  await client.put(
    `/api/shipping/api/customers/${props.customerId}/users/${props.userId}?redirectTo=${encodeURIComponent(
      ACCOUNT_SETTINGS_PAGE_URL
    )}`,
    props.data
  )
}

export type UpdatePasswordProps = {
  customerId: string
  userId: string
  data: {
    currentPassword: string
    password: string
  }
}

export const updatePassword = async (props: UpdatePasswordProps): Promise<void> => {
  await client.put(
    `/api/shipping/api/customers/${props.customerId}/users/${props.userId}?redirectTo=${encodeURIComponent(
      ACCOUNT_SETTINGS_PAGE_URL
    )}`,
    props.data
  )
}

export const isCurrentPassswordError = (error: unknown): boolean =>
  error instanceof Error && error.message === 'The current password is not correct'
